module.exports = __webpack_public_path__ + "static/img/p-hx-1.d10ee49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-hx-1.png
// module id = IceP
// module chunks = 0